import React, { ComponentPropsWithRef, useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
import { LeftArrowIcon } from "shared-components/Components/CustomIcons/LeftArrowIcon/web";
import { RightArrowIcon } from "shared-components/Components/CustomIcons/RightArrowIcon/web";

type UsePrevNextButtonsType = {
	prevBtnDisabled: boolean;
	nextBtnDisabled: boolean;
	onPrevButtonClick: () => void;
	onNextButtonClick: () => void;
};

export const usePrevNextButtons = (
	emblaApi: EmblaCarouselType | undefined
): UsePrevNextButtonsType => {
	const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
	const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

	const onPrevButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollPrev();
	}, [emblaApi]);

	const onNextButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollNext();
	}, [emblaApi]);

	const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
		setPrevBtnDisabled(!emblaApi.canScrollPrev());
		setNextBtnDisabled(!emblaApi.canScrollNext());
	}, []);

	useEffect(() => {
		if (!emblaApi) return;

		onSelect(emblaApi);
		emblaApi.on("reInit", onSelect).on("select", onSelect);
	}, [emblaApi, onSelect]);

	return {
		prevBtnDisabled,
		nextBtnDisabled,
		onPrevButtonClick,
		onNextButtonClick,
	};
};

type PropType = ComponentPropsWithRef<"button">;

export const PrevButton: React.FC<PropType> = props => {
	const { children, ...restProps } = props;

	return (
		<button className="emblaGalleryCarousel__navigation emblaGalleryCarousel__navigation--left" type="button" {...restProps}>
			<LeftArrowIcon  />
			{children}
		</button>
	);
};

export const NextButton: React.FC<PropType> = props => {
	const { children, ...restProps } = props;

	return (
		<button className="emblaGalleryCarousel__navigation emblaGalleryCarousel__navigation--right" type="button" {...restProps}>
			<RightArrowIcon />
			{children}
		</button>
	);
};
